import React from 'react';

import { AttachmentBadge } from '../composer/attachments/badge';

import type { Message } from '../types';

interface Props {
  message: Message;
}

export default function UserMessage({ message }: Props) {
  return (
    <div className="d-flex flex-column align-items-end mb-3">
      {message.interrupting && <div className="text-muted small mb-1">Interrupted</div>}
      {message.attachments && message.attachments.length > 0 && (
        <div className="d-flex flex-wrap justify-content-end gap-1 mb-1" style={{ maxWidth: '85%' }}>
          {message.attachments.map((attachment, index) => (
            <AttachmentBadge key={index} name={attachment.name} />
          ))}
        </div>
      )}
      {/* Plain text, straight from the composer: Shift+Enter puts real newlines in it, and a pasted
          URL arrives as one unbreakable token. Neither survives the default white-space handling. */}
      <div
        className="bg-light rounded-3 p-2"
        style={{ maxWidth: '85%', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}
      >
        {message.content}
      </div>
    </div>
  );
}
